<template>
  <div id="user-edit-tab-info">
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/2">
        <!-- Col Header -->
        <div class="flex items-end mb-5">
          <feather-icon icon="LockIcon" class="mr-2" svgClasses="w-5 h-5" />
          <span class="leading-none font-medium">Change Password</span>
        </div>

        <!-- Col Content -->
        <div class="mb-3">
          <label for="Current Password" class="text-xs">Current Password</label>
          <vx-input-group class="w-full">
            <vs-input
              v-validate="'required'"
              :type="!form.showOldPassword && 'password'"
              name="Current Password"
              icon-no-border
              icon="icon icon-lock"
              icon-pack="feather"
              v-model="form.oldPassword"
              class="w-full"
            />
            <template slot="append">
              <div class="append-text btn-addon">
                <vs-button icon-pack="feather" :icon="form.showOldPassword ? 'icon icon-eye' : 'icon icon-eye-off'" @click="form.showOldPassword = !form.showOldPassword" />
              </div>
              <!-- <div class="append-text bg-primary">
                          <feather-icon class="mr-0 cursor-pointer" svg-classes="stroke-current text-primary"  />
                        </div> -->
            </template>
          </vx-input-group>
          <!-- <vs-input
            icon="icon icon-lock"
            icon-pack="feather"
            type="password"
            class="w-full mt-4"
            label="Current Password"
            v-model="form.oldPassword"
            name="Current Password"
            v-validate="'required|min:6'"
          /> -->
          <span class="text-danger text-sm" v-show="errors.has('Current Password')">{{ errors.first('Current Password') }}</span>
        </div>
        <div class="mb-3">
          <label for="New Password" class="text-xs">New Password</label>
          <vx-input-group class="w-full">
            <vs-input
              v-validate="'required'"
              :type="!form.showNewPassword && 'password'"
              name="New Password"
              icon-no-border
              icon="icon icon-lock"
              icon-pack="feather"
              v-model="form.newPassword"
              class="w-full"
            />
            <template slot="append">
              <div class="append-text btn-addon">
                <vs-button icon-pack="feather" :icon="form.showNewPassword ? 'icon icon-eye' : 'icon icon-eye-off'" @click="form.showNewPassword = !form.showNewPassword" />
              </div>
              <!-- <div class="append-text bg-primary">
                          <feather-icon class="mr-0 cursor-pointer" svg-classes="stroke-current text-primary"  />
                        </div> -->
            </template>
          </vx-input-group>
          <!-- <vs-input
            icon="icon icon-lock"
            icon-pack="feather"
            type="password"
            ref="password"
            class="w-full mt-4"
            label="New Password"
            v-model="form.newPassword"
            name="New Password"
            v-validate="'required|min:6'"
          /> -->
          <span class="text-danger text-sm" v-show="errors.has('New Password')">{{ errors.first('New Password') }}</span>
        </div>
        <div class="mb-3">
          <label for="Confirm Password" class="text-xs">Confirm Password</label>
          <vx-input-group class="w-full">
            <vs-input
              v-validate="'required'"
              :type="!form.showConfirmPassword && 'password'"
              name="Confirm Password"
              icon-no-border
              icon="icon icon-lock"
              icon-pack="feather"
              v-model="form.confirmPassword"
              class="w-full"
            />
            <template slot="append">
              <div class="append-text btn-addon">
                <vs-button icon-pack="feather" :icon="form.showConfirmPassword ? 'icon icon-eye' : 'icon icon-eye-off'" @click="form.showConfirmPassword = !form.showConfirmPassword" />
              </div>
              <!-- <div class="append-text bg-primary">
                          <feather-icon class="mr-0 cursor-pointer" svg-classes="stroke-current text-primary"  />
                        </div> -->
            </template>
          </vx-input-group>
          <!-- <vs-input
            icon="icon icon-lock"
            icon-pack="feather"
            type="password"
            class="w-full mt-4"
            label="Confirm Password"
            v-model="form.confirmPassword"
            name="Confirm Password"
            v-validate="'required|min:6|confirmed:password'"
          /> -->
          <span class="text-danger text-sm" v-show="errors.has('Confirm Password')">{{ errors.first('Confirm Password') }}</span>
        </div>
      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2 vs-con-loading__container" id="change-password-button" type="relief" @click="save_changes" :disabled="!validateForm || processing">Save Password</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicSelect from '@/components/custom/form-elements/DynamicSelect.vue'

export default {
  data() {
    return {
      form: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
        showOldPassword: false,
        showNewPassword: false,
        showConfirmPassword: false
      },
      processing: false
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any()
    }
  },
  mounted() {},
  methods: {
    async save_changes() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please Fill The Form',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        return
      }
      this.processing = true
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: '#change-password-button',
        scale: 0.45
      })
      try {
        const { message } = await this.$store.dispatch('auth/changePassword', this.form)
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })

        //clear the form
        delete this.form.newPassword
        delete this.form.oldPassword
        delete this.form.confirmPassword

        this.errors.clear()
      } catch (e) {
        this.$vs.notify({
          title: 'Error',
          text: Object.values(e.errors)[0],
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
      this.processing = false
      this.$vs.loading.close('#change-password-button > .con-vs-loading')
    }
  },
  components: {
    DynamicSelect
  }
}
</script>